import { render } from "./FormEvent.vue?vue&type=template&id=232fa0bb&ts=true"
import script from "./FormEvent.vue?vue&type=script&lang=ts"
export * from "./FormEvent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__